import * as React from "react";
import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { HoverForHelp, Select, Spinner, IconButton } from "components/common";
import useValuesOf from "enterprise/parameters/components/option/useValuesOf";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const InputAddition = styled.div`
  display: table-cell;
  vertical-align: middle;
  padding-left: 5px;
`;
const SelectContainerDiv = styled.div`
  min-width: 200px;
`;
const ErrorInfo = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
const SelectContainer = ({ children, innerRef, innerProps }) => /* @__PURE__ */ React.createElement(SelectContainerDiv, { ref: innerRef, ...innerProps }, children);
const LoadingIndicator = () => /* @__PURE__ */ React.createElement(InputAddition, null, /* @__PURE__ */ React.createElement(Spinner, null));
const OptionParameterInput = ({
  parameter,
  onChange,
  value,
  searchId,
  inputSize
}) => {
  const { t } = useTranslation("enterprise_common");
  const { data: fieldValues, isFetching, isLoading, isError, error, refetch } = useValuesOf(parameter, searchId);
  const options = useMemo(
    () => fieldValues ? fieldValues.map((v) => ({ key: v, value: v, label: String(v) })) : [],
    [fieldValues]
  );
  const _onChange = useCallback(
    (selected) => onChange(parameter.name, selected, true),
    [onChange, parameter.name]
  );
  if (isLoading || isFetching) {
    return /* @__PURE__ */ React.createElement(LoadingIndicator, null);
  }
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    Select,
    {
      placeholder: t("parameters.option_input.select_or_enter"),
      components: { SelectContainer },
      displayKey: "key",
      valueKey: "value",
      size: inputSize === "small" ? "small" : "normal",
      inputId: "parameter-value-input",
      allowCreate: true,
      onChange: _onChange,
      options,
      value
    }
  ), /* @__PURE__ */ React.createElement(InputAddition, null, /* @__PURE__ */ React.createElement(IconButton, { title: t("parameters.option_input.refresh_values"), name: "refresh", onClick: refetch })), isError && /* @__PURE__ */ React.createElement(ErrorInfo, { title: t("parameters.option_input.error"), type: "error", iconSize: "lg" }, "responseMessage" in error && error.responseMessage ? error.responseMessage : String(error)));
};
export default OptionParameterInput;
